import React, {useState, useEffect} from 'react';
import ProducerTree from '@/views/Layout/b2b/ProducerNavBar/ProducerTree';

// FIXME: add a Delay on ProducerTree rendering because after embedded
// vendor's menu (angular), sometime the global.jQuery().jstree is undefined
// causing the header crash, now delay the rendering and attempt to render
// only if plug-in is responsible to minimize the problem at this moment
const Delay = ({children, nextInterval = 500}: Props) => {
  const [isShown, setIsShown] = useState(false);

  useEffect(
    () => {
      const id = setInterval(() => {
        if (global.jQuery().jstree) {
          setIsShown(true);
          clearInterval(id);
        }
      }, nextInterval);

      return () => clearInterval(id);
    },
    [isShown]
  );

  return isShown ? children : null;
};

const ProducerNav = () => (
  <>
    <div className='pt-3 pb-1'>
      <Delay>
        <ProducerTree />
      </Delay>
    </div>
  </>
);

export default ProducerNav;
